module.exports = __webpack_public_path__ + "static/media/Icon-caret-blue.5997c186.png";